import { Injectable } from '@angular/core';
import 'rxjs';
import { Observable, Observer } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class ObservableManager {

  private showObserver: Observer<boolean>;
  public showObservable: Observable<boolean>;

  constructor() {
    this.showObservable = new Observable<boolean>(observer => {
      this.showObserver = observer;
    }
    ).pipe(share());
  }

  public show() {
    if (this.showObserver) {
      this.showObserver.next(true);
    }
  }

  public hide() {
    if (this.showObserver) {
      this.showObserver.next(false);
    }
  }

}
